import * as React from 'react';

const ThemeContext = React.createContext('light');

/**
 * Wraps App.js theme state so deep components (chart wrappers, etc.)
 * can read the current theme without prop drilling.
 *
 * Usage in App.js:
 *   import { ThemeProvider } from './contexts/ThemeContext';
 *   <ThemeProvider value={theme}> ... </ThemeProvider>
 */
function ThemeProvider({ value, children }) {
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

function useTheme() {
  return React.useContext(ThemeContext);
}

export { ThemeProvider, useTheme };
